import './styles/globals.css';
import Cursor     from './components/Cursor';
import Nav        from './components/Nav';
import Hero       from './components/Hero';
import About      from './components/About';
import Stack      from './components/Stack';
import Experience from './components/Experience';
import Projects   from './components/Projects';
import Skills     from './components/Skills';
import Contact    from './components/Contact';
import Footer     from './components/Footer';

export default function App() {
  return (
    <>
      <Cursor />
      <div className="relative z-10">
        <Nav />
        <Hero />
        <About />
        <Stack />
        <Experience />
        <Projects />
        <Skills />
        <Contact />
        <Footer />
      </div>
    </>
  );
}
